import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Tab,
  Tabs,
  Button,
  Tooltip,
  TextField,
  Modal,
  Typography,
  CircularProgress,
} from '@mui/material';
import { AccountCircle } from '@mui/icons-material';

import { useHeaderStyles } from './styles';
import BookSession from '../../../components/BookSession';
import PropVuLogo from '../../../utils/assets/PropVuLogo.svg';
import { HomeViewType, IUserSettings } from '../../../global/interfaces';
import BookingModal from '../../../components/BookingModal';
import { useBookingsContext } from '../../../contexts/BookingsContext';
import useBookings from '../../../hooks/useBookings';
import { IBooking } from '@homeporter/types';
interface IProps {
  handleOpenSettingsModal: () => void;
  homeView: HomeViewType;
  setHomeView: (tab: HomeViewType) => void;
  userSettings?: IUserSettings;
}

const Header = ({
  handleOpenSettingsModal,
  homeView,
  setHomeView,
  userSettings,
}: IProps) => {
  const styles = useHeaderStyles();
  const navigate = useNavigate();
  const { getBookingJoinFromCode } = useBookings();
  const [waitAndOpenBookingModal, setWaitAndOpenBookingModal] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const {
    bookings,
    setIsBookingModalOpen,
    setBookingModalUrl,
    selectedBooking,
    setEditBooking,
    setSelectedBooking,
    refetchBookings,
  } = useBookingsContext();

  const [joinCodeError, setJoinCodeError] = useState(false);
  const [fetchingJoinCode, setFetchingJoinCode] = useState(false);
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [sessionCode, setSessionCode] = useState('');

  const onTabSelect = (event: any, value: HomeViewType) => {
    setHomeView(value);
  };

  const startSession = async () => {
    console.log('calling startSession');

    try {
      setFetchingJoinCode(true);
      const response = await getBookingJoinFromCode.mutateAsync(sessionCode);

      if (response.status === 'success') {
        const _bookings = response.new_join_code
          ? (await refetchBookings())?.data
          : bookings;

        setTimeout(() => {
          const booking = _bookings?.find((booking: IBooking) => {
            return booking.booking_id === response.booking.booking_id;
          });

          setJoinModalOpen(false);
          setFetchingJoinCode(false);
          if (!booking) return;

          setSelectedBooking(booking);
          navigate(`inspector/${booking.booking_session_code}`);
        }, 300);
      } else {
        throw new Error('Error, response status is not success');
      }
    } catch (error) {
      console.error('error', error);
      setFetchingJoinCode(false);
      setJoinCodeError(true);
      setTimeout(() => {
        setJoinCodeError(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (waitAndOpenBookingModal && !selectedBooking) {
      setBookingModalUrl('booking-spot');
      setIsBookingModalOpen(true);
      setWaitAndOpenBookingModal(false);
    }
  }, [waitAndOpenBookingModal, selectedBooking]);

  return (
    <AppBar sx={styles.appBar} position="static">
      <Toolbar disableGutters id="navbar" sx={{ pl: 0, ml: 0 }}>
        <IconButton
          disableRipple
          size="large"
          component={Link}
          to="/"
          edge="start"
          color="inherit"

          aria-label="menu">
          <img src={PropVuLogo} alt="Company Logo" style={styles.navbarLogo} />
        </IconButton>

        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            marginRight: 'auto',
            marginLeft: '4rem',
          }}>
          {false && userSettings?.dev && (
            <Tabs
              sx={styles.tabs}
              value={homeView}
              onChange={onTabSelect}
              aria-label="Top Navigation">
              {userSettings?.dev && <Tab label="Schedule" value={'schedule'} />}
              {userSettings?.dev && <Tab label="Calendar" value={'calendar'} />}
              {/* <Tab label="Reports" value={'reports'} /> */}
              {/* <Tab label="HomeOwners" value={'homeowners'} /> */}
            </Tabs>
          )}
        </Box>

        <Box sx={styles.navbarIcons}>
          <div>
            <Tooltip title="Join Session With Code">
              <Button
                sx={styles.navbarBooking}
                onClick={() => {
                  setFetchingJoinCode(false);
                  setJoinModalOpen(true);
                }}>
                Join
              </Button>
            </Tooltip>
            <Tooltip title="Book Appointment...">
              <Button
                sx={styles.navbarBooking}
                onClick={() => {
                  //setBookingCalendarModalOpen(true);
                  setEditBooking(null);
                  setSelectedBooking(null);
                  setWaitAndOpenBookingModal(true);
                }}>
                Book Appointment
              </Button>
            </Tooltip>

            <BookSession
              open={bookingModalOpen}
              onClose={() => setBookingModalOpen(false)}
            />
          </div>
          <IconButton
            size="large"
            color="inherit"
            onClick={handleOpenSettingsModal}>
            <AccountCircle sx={styles.navbarIcon} />
          </IconButton>
        </Box>
      </Toolbar>
      <BookingModal />
      <Modal
        open={joinModalOpen}
        onClose={() => setJoinModalOpen(false)}
        aria-labelledby="join-session-modal"
        aria-describedby="enter-session-code">
        <Box sx={styles.joinModal}>
          <Typography variant="h6" component="h2" mb={2}>
            Join Session
          </Typography>
          <TextField
            fullWidth
            label="Enter Session Code"
            value={sessionCode}
            onChange={(e) => setSessionCode(e.target.value.toUpperCase())}
            sx={{ mb: '1.5rem' }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={() => setJoinModalOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={sessionCode.length < 6 || fetchingJoinCode}
              onClick={() => {
                startSession();
              }}>
              {fetchingJoinCode ? (
                <CircularProgress size={20} />
              ) : joinCodeError ? (
                'Error'
              ) : (
                'Start Session'
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </AppBar>
  );
};

export default Header;
